import config from "../../../config/config";

const generateHtmlContent = (details) => {
  const pad2 = (v) => String(v).padStart(2, '0');

  const formattedDate = details.formattedDate
    ? details.formattedDate
    : `${pad2(details.date.month)}/${pad2(details.date.day)}/${details.date.year}`;

  const formattedTime = details.formattedTime
    ? details.formattedTime
    : `${pad2(details.time.hours)}:${pad2(details.time.minutes)} ${details.time.ampm}`;

  const confirmAttendanceUrl = `${config.HOME_URL}/account/fs-dashboard/schedules/${details.messageId}`;

  return `
    <html lang="en">
      <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Meet and Greet Scheduled</title>
      </head>
      <body style="font-family: 'Quicksand', sans-serif; background-color: #f4f4f4; margin: 0; padding: 0;">
        <div style="background-color: #ffffff; width: 100%; max-width: 80%; margin: 0 auto; padding: 2px 20px; box-shadow: 0 4px 8px rgba(0,0,0,0.1);">
          <p style="color: #666666; line-height: 1.5; font-size: 15px;">
            Dear <strong>${details.recipientFullName}</strong>,
          </p>
          <p style="color: #666666; line-height: 1.5; font-size: 15px;">
            Great news! <strong style="color: #1d5d86; text-decoration: none;">${details.schedulerName}</strong> from your recent conversation about
            "<strong style="color: #1d5d86; text-decoration: none;">${details.jobTitle}</strong>" job you recently posted has scheduled an introductory meeting. See details below:
          </p>
          <div style="background-color: #f7f7f7; border-radius: 5px; padding: 2px 0 2px 10px;">
            <p style="color: #333; font-size: 15px;"><strong>Date:</strong> ${formattedDate}</p>
            <p style="color: #333; font-size: 15px;"><strong>Time:</strong> ${formattedTime}</p>
            <p style="color: #333; font-size: 15px;"><strong>Duration:</strong> ${details.duration}</p>
            <p style="color: #333; font-size: 15px;"><strong>Preferred Method:</strong> ${details.preferredMethod}</p>
          </div>
          <p style="color: #666666; line-height: 1.5; font-size: 15px;">
            Please confirm your attendance for the scheduled time below.
          </p>
          <a href="${confirmAttendanceUrl}" style="display: inline-block; background-color: #359136; color: white; padding: 10px 20px; text-align: center; border-radius: 5px; text-decoration: none; font-size: 16px; margin: 10px 0;">
            Confirm Attendance
          </a>
          <a href="${details.googleLink}" style="display: inline-block; background-color: #1d3f52; color: white; padding: 10px 20px; text-align: center; border-radius: 5px; text-decoration: none; font-size: 16px; margin: 10px 0;">
            Add to Google Calendar
          </a>
          <a href="${details.outlookLink}" style="display: inline-block; background-color: #0072C6; color: white; padding: 10px 20px; text-align: center; border-radius: 5px; text-decoration: none; font-size: 16px; margin: 10px 0;">
            Add to Outlook Calendar
          </a>
          <p style="color: #666666; line-height: 1.5; font-size: 15px;">
            If the proposed time doesn't work for your schedule, feel free to suggest an alternative time via chat.
          </p>
          <a href="${config.HOME_URL}/account/fs-dashboard/inbox/${details.messageId}" style="display: inline-block; background-color: #1d5d86; color: white; padding: 10px 20px; text-align: center; border-radius: 5px; text-decoration: none; font-size: 16px; margin: 10px 0;">
            Suggest an Alternative Time
          </a>
          <p style="color: #666666; line-height: 1.5; font-size: 15px;">Sincerely,</p>
          <p style="color: #666666; line-height: 1.5; font-size: 16px;"><strong>One Support Hub Team</strong></p>
        </div>
      </body>
    </html>
  `;
};

export default generateHtmlContent;


